import { useEffect, useRef } from "react";
import api from "@/lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const processed = useRef(false);
  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { window.location.href = "/accedi"; return; }
    api.post("/auth/google", { session_id: m[1] })
      .then((res) => {
        localStorage.setItem("ppc_token", res.data.token);
        const u = res.data.user;
        if (u.role === "admin" || u.role === "manager") {
          window.location.href = "/admin";
        } else if (u.contract_version !== "v1.0") {
          window.location.href = "/contratto";
        } else {
          window.location.href = "/dashboard";
        }
      })
      .catch(() => { window.location.href = "/accedi?err=google"; });
  }, []);
  return (
    <div className="min-h-screen bg-[#0A1128] flex items-center justify-center text-[#D4AF37]">
      Accesso in corso…
    </div>
  );
}
